import _regeneratorRuntime from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function applyDefaults(options) {
  if (!options) {
    options = {};
  }

  return {
    delay: options.delay === undefined ? 200 : options.delay,
    initialDelay: options.initialDelay === undefined ? 0 : options.initialDelay,
    minDelay: options.minDelay === undefined ? 0 : options.minDelay,
    maxDelay: options.maxDelay === undefined ? 0 : options.maxDelay,
    factor: options.factor === undefined ? 0 : options.factor,
    maxAttempts: options.maxAttempts === undefined ? 3 : options.maxAttempts,
    timeout: options.timeout === undefined ? 0 : options.timeout,
    jitter: options.jitter === true,
    handleError: options.handleError === undefined ? null : options.handleError,
    handleTimeout: options.handleTimeout === undefined ? null : options.handleTimeout,
    beforeAttempt: options.beforeAttempt === undefined ? null : options.beforeAttempt,
    calculateDelay: options.calculateDelay === undefined ? null : options.calculateDelay
  };
}

export function sleep(_x) {
  return _sleep.apply(this, arguments);
}

function _sleep() {
  _sleep = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(delay) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              setTimeout(resolve, delay);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sleep.apply(this, arguments);
}

export function defaultCalculateDelay(context, options) {
  var delay = options.delay;

  if (delay === 0) {
    // no delay between attempts
    return 0;
  }

  if (options.factor) {
    delay *= Math.pow(options.factor, context.attemptNum - 1);

    if (options.maxDelay !== 0) {
      delay = Math.min(delay, options.maxDelay);
    }
  }

  if (options.jitter) {
    // Jitter will result in a random value between `minDelay` and
    // calculated delay for a given attempt.
    // See https://www.awsarchitectureblog.com/2015/03/backoff.html
    // We're using the "full jitter" strategy.
    var min = Math.ceil(options.minDelay);
    var max = Math.floor(delay);
    delay = Math.floor(Math.random() * (max - min + 1)) + min;
  }

  return Math.round(delay);
}
export function retry(_x2, _x3) {
  return _retry.apply(this, arguments);
}

function _retry() {
  _retry = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(attemptFunc, attemptOptions) {
    var options, _i, _arr, prop, value, context, calculateDelay, makeAttempt, _makeAttempt, initialDelay;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _makeAttempt = function _ref3() {
              _makeAttempt = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee3() {
                var err, onError;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (options.beforeAttempt) {
                          options.beforeAttempt(context, options);
                        }

                        if (!context.aborted) {
                          _context3.next = 5;
                          break;
                        }

                        err = new Error("Attempt aborted");
                        err.code = 'ATTEMPT_ABORTED';
                        throw err;

                      case 5:
                        onError =
                        /*#__PURE__*/
                        function () {
                          var _ref = _asyncToGenerator(
                          /*#__PURE__*/
                          _regeneratorRuntime.mark(function _callee2(err) {
                            var delay;
                            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    if (!options.handleError) {
                                      _context2.next = 3;
                                      break;
                                    }

                                    _context2.next = 3;
                                    return options.handleError(err, context, options);

                                  case 3:
                                    if (!(context.aborted || context.attemptsRemaining === 0)) {
                                      _context2.next = 5;
                                      break;
                                    }

                                    throw err;

                                  case 5:
                                    // We are about to try again so increment attempt number
                                    context.attemptNum++;
                                    delay = calculateDelay(context, options);

                                    if (!delay) {
                                      _context2.next = 10;
                                      break;
                                    }

                                    _context2.next = 10;
                                    return sleep(delay);

                                  case 10:
                                    return _context2.abrupt("return", makeAttempt());

                                  case 11:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }));

                          return function onError(_x4) {
                            return _ref.apply(this, arguments);
                          };
                        }();

                        if (context.attemptsRemaining > 0) {
                          context.attemptsRemaining--;
                        }

                        if (!options.timeout) {
                          _context3.next = 11;
                          break;
                        }

                        return _context3.abrupt("return", new Promise(function (resolve, reject) {
                          var timer = setTimeout(function () {
                            if (options.handleTimeout) {
                              // If calling handleTimeout throws an error that is not wrapped in a promise
                              // we want to catch the error and reject.
                              try {
                                resolve(options.handleTimeout(context, options));
                              } catch (e) {
                                reject(e);
                              }
                            } else {
                              var _err = new Error("Retry timeout (attemptNum: ".concat(context.attemptNum, ", timeout: ").concat(options.timeout, ")"));

                              _err.code = 'ATTEMPT_TIMEOUT';
                              reject(_err);
                            }
                          }, options.timeout);
                          attemptFunc(context, options).then(function (result) {
                            clearTimeout(timer);
                            resolve(result);
                          }).catch(function (err) {
                            clearTimeout(timer); // Calling resolve with a Promise that rejects here will result
                            // in an unhandled rejection. Calling `reject` with errors
                            // does not result in an unhandled rejection

                            onError(err).then(resolve).catch(reject);
                          });
                        }));

                      case 11:
                        return _context3.abrupt("return", attemptFunc(context, options).catch(onError));

                      case 12:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));
              return _makeAttempt.apply(this, arguments);
            };

            makeAttempt = function _ref2() {
              return _makeAttempt.apply(this, arguments);
            };

            options = applyDefaults(attemptOptions);
            _i = 0, _arr = ['delay', 'initialDelay', 'minDelay', 'maxDelay', 'maxAttempts', 'timeout'];

          case 4:
            if (!(_i < _arr.length)) {
              _context4.next = 12;
              break;
            }

            prop = _arr[_i];
            value = options[prop];

            if (!(!Number.isInteger(value) || value < 0)) {
              _context4.next = 9;
              break;
            }

            throw new Error("Value for ".concat(prop, " must be an integer greater than or equal to 0"));

          case 9:
            _i++;
            _context4.next = 4;
            break;

          case 12:
            if (!(options.factor.constructor !== Number || options.factor < 0)) {
              _context4.next = 14;
              break;
            }

            throw new Error("Value for factor must be a number greater than or equal to 0");

          case 14:
            if (!(options.delay < options.minDelay)) {
              _context4.next = 16;
              break;
            }

            throw new Error("delay cannot be less than minDelay (delay: ".concat(options.delay, ", minDelay: ").concat(options.minDelay));

          case 16:
            context = {
              attemptNum: 0,
              attemptsRemaining: options.maxAttempts ? options.maxAttempts : -1,
              aborted: false,
              abort: function abort() {
                context.aborted = true;
              }
            };
            calculateDelay = options.calculateDelay || defaultCalculateDelay;
            initialDelay = options.calculateDelay ? options.calculateDelay(context, options) : options.initialDelay;

            if (!initialDelay) {
              _context4.next = 22;
              break;
            }

            _context4.next = 22;
            return sleep(initialDelay);

          case 22:
            return _context4.abrupt("return", makeAttempt());

          case 23:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _retry.apply(this, arguments);
}